export default {
  GET_ALLIANZ_INVESTMENT_TYPE_QUERY: Symbol.for('GET_ALLIANZ_INVESTMENT_TYPE_QUERY'),
  ALLIANZ_INVESTMENT_TYPE_REPOSITORY: Symbol.for('ALLIANZ_INVESTMENT_TYPE_REPOSITORY'),
  ALLIANZ_INVESTMENT_TYPE_STATE_MANAGER: Symbol.for('ALLIANZ_INVESTMENT_TYPE_STATE_MANAGER'),
};
